import React from "react";
import { Grid, Card, Box, Skeleton, Container } from "@mui/material";

/**
 * OffersFilterBarSkeleton Component
 *
 * Loading skeleton for the Offers filter bar
 */
export const OffersFilterBarSkeleton: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {/* Category Chips Skeleton */}
      <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            width={100}
            height={32}
            sx={{ borderRadius: 2 }}
          />
        ))}
      </Box>

      {/* Search and Sort Skeleton */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={8}>
          <Skeleton variant="rounded" height={56} sx={{ borderRadius: 3 }} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="rounded" height={56} sx={{ borderRadius: 3 }} />
        </Grid>
      </Grid>
    </Container>
  );
};

/**
 * OffersSkeleton Component
 *
 * Loading skeleton for the offers grid
 */
const OffersSkeleton: React.FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3, md: 3 }}>
      {[...Array(6)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: "100%", borderRadius: 2 }}>
            <Skeleton variant="rectangular" height={200} />
            <Box sx={{ p: 2 }}>
              <Skeleton
                variant="rounded"
                width="40%"
                height={24}
                sx={{ mb: 1.5 }}
              />
              <Skeleton
                variant="text"
                width="90%"
                sx={{ fontSize: "1.5rem", mb: 1 }}
              />
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: "1.5rem", mb: 2 }}
              />
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <Skeleton variant="rounded" width={80} height={28} />
                <Skeleton variant="rounded" width={100} height={28} />
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width="60%" />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default OffersSkeleton;
